import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { JSX } from 'react';
import styled from 'styled-components';
import { colors, shadows } from '../../theme';
import { colors as newColors } from '../../theme/colors';
interface GenericObject {
  [key: string]: string;
}
const backgroundColors: GenericObject = {
  dark: colors.primary_xd,
  light: '#aaa',
  extraLight: colors.gray_xl,
  primary: colors.primary,
  transparent: 'transparent',
  white: '#fff'
};
export type BorderRadius = 0 | 3 | 4 | 6 | 10;
type BoxShadow = 'overlay' | 'card' | 'none';
type BackgroundColors = 'white' | 'light' | 'dark';
type BorderStyle = 'none' | 'hidden' | 'dotted' | 'dashed' | 'solid' | 'double' | 'groove' | 'ridge' | 'inset' | 'outset';
interface Props {
  id?: string;
  testId?: string;
  backgroundColor?: BackgroundColors | string;
  border?: number;
  borderStyle?: BorderStyle;
  borderTop?: number;
  borderLeft?: number;
  borderRight?: number;
  borderBottom?: number;
  borderRadius?: BorderRadius;
  borderTopRadius?: BorderRadius;
  borderRightRadius?: BorderRadius;
  borderBottomRadius?: BorderRadius;
  borderLeftRadius?: BorderRadius;
  boxShadow?: BoxShadow;
  children: React.ReactNode;
  elementRef?: React.RefObject<HTMLElement | null>;
  style?: React.CSSProperties;
  width?: number | string;
  onClick?: () => unknown;
}
type StyledBoxProps = Props;
export function Box(props) {
  const $ = _c(44);
  let children;
  let elementRef;
  let id;
  let onClick;
  let rest;
  let style;
  let t0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  let testId;
  let width;
  if ($[0] !== props) {
    ({
      backgroundColor: t0,
      border: t1,
      borderStyle: t2,
      borderTop: t3,
      borderLeft: t4,
      borderRight: t5,
      borderBottom: t6,
      borderRadius: t7,
      borderTopRadius: t8,
      borderBottomRadius: t9,
      borderRightRadius: t10,
      borderLeftRadius: t11,
      boxShadow: t12,
      children,
      id,
      testId,
      elementRef,
      style,
      width,
      onClick,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = elementRef;
    $[3] = id;
    $[4] = onClick;
    $[5] = rest;
    $[6] = style;
    $[7] = t0;
    $[8] = t1;
    $[9] = t10;
    $[10] = t11;
    $[11] = t12;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
    $[20] = testId;
    $[21] = width;
  } else {
    children = $[1];
    elementRef = $[2];
    id = $[3];
    onClick = $[4];
    rest = $[5];
    style = $[6];
    t0 = $[7];
    t1 = $[8];
    t10 = $[9];
    t11 = $[10];
    t12 = $[11];
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
    testId = $[20];
    width = $[21];
  }
  const backgroundColor = t0 === undefined ? "transparent" : t0;
  const border = t1 === undefined ? 0 : t1;
  const borderStyle = t2 === undefined ? "solid" : t2;
  const borderTop = t3 === undefined ? 0 : t3;
  const borderLeft = t4 === undefined ? 0 : t4;
  const borderRight = t5 === undefined ? 0 : t5;
  const borderBottom = t6 === undefined ? 0 : t6;
  const borderRadius = t7 === undefined ? 0 : t7;
  const borderTopRadius = t8 === undefined ? 0 : t8;
  const borderBottomRadius = t9 === undefined ? 0 : t9;
  const borderRightRadius = t10 === undefined ? 0 : t10;
  const borderLeftRadius = t11 === undefined ? 0 : t11;
  const boxShadow = t12 === undefined ? "none" : t12;
  const boxBackgroundColor = backgroundColors[backgroundColor];
  const widthStyle = typeof width === "string" ? width : `${width}px`;
  const t13 = elementRef as React.RefObject<HTMLDivElement | null>;
  const t14 = boxBackgroundColor || backgroundColor;
  let t15;
  if ($[22] !== border || $[23] !== borderBottom || $[24] !== borderBottomRadius || $[25] !== borderLeft || $[26] !== borderLeftRadius || $[27] !== borderRadius || $[28] !== borderRight || $[29] !== borderRightRadius || $[30] !== borderStyle || $[31] !== borderTop || $[32] !== borderTopRadius || $[33] !== boxShadow || $[34] !== children || $[35] !== id || $[36] !== onClick || $[37] !== rest || $[38] !== style || $[39] !== t13 || $[40] !== t14 || $[41] !== testId || $[42] !== widthStyle) {
    t15 = <StyledBox ref={t13} style={style} id={id} data-testid={testId} backgroundColor={t14} border={border} borderStyle={borderStyle} borderTop={borderTop} borderLeft={borderLeft} borderRight={borderRight} borderBottom={borderBottom} borderRadius={borderRadius} borderTopRadius={borderTopRadius} borderBottomRadius={borderBottomRadius} borderRightRadius={borderRightRadius} borderLeftRadius={borderLeftRadius} boxShadow={boxShadow} width={widthStyle} onClick={onClick} {...rest}>{children}</StyledBox>;
    $[22] = border;
    $[23] = borderBottom;
    $[24] = borderBottomRadius;
    $[25] = borderLeft;
    $[26] = borderLeftRadius;
    $[27] = borderRadius;
    $[28] = borderRight;
    $[29] = borderRightRadius;
    $[30] = borderStyle;
    $[31] = borderTop;
    $[32] = borderTopRadius;
    $[33] = boxShadow;
    $[34] = children;
    $[35] = id;
    $[36] = onClick;
    $[37] = rest;
    $[38] = style;
    $[39] = t13;
    $[40] = t14;
    $[41] = testId;
    $[42] = widthStyle;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  return t15;
}
const StyledBox = styled.div<StyledBoxProps>`
  background-color: ${({
  backgroundColor
}: StyledBoxProps) => backgroundColor};
  border-color: ${newColors.steel[200]};
  border-style: ${({
  borderStyle
}: StyledBoxProps) => borderStyle};
  border-top-width: ${({
  borderTop,
  border
}: StyledBoxProps) => borderTop || border}px;
  border-left-width: ${({
  borderLeft,
  border
}: StyledBoxProps) => borderLeft || border}px;
  border-right-width: ${({
  borderRight,
  border
}: StyledBoxProps) => borderRight || border}px;
  border-bottom-width: ${({
  borderBottom,
  border
}: StyledBoxProps) => borderBottom || border}px;
  border-top-left-radius: ${({
  borderTopRadius,
  borderLeftRadius,
  borderRadius
}: StyledBoxProps) => borderTopRadius || borderLeftRadius || borderRadius}px;
  border-top-right-radius: ${({
  borderTopRadius,
  borderRightRadius,
  borderRadius
}: StyledBoxProps) => borderTopRadius || borderRightRadius || borderRadius}px;
  border-bottom-left-radius: ${({
  borderBottomRadius,
  borderLeftRadius,
  borderRadius
}: StyledBoxProps) => borderBottomRadius || borderLeftRadius || borderRadius}px;
  border-bottom-right-radius: ${({
  borderBottomRadius,
  borderRightRadius,
  borderRadius
}: StyledBoxProps) => borderBottomRadius || borderRightRadius || borderRadius}px;
  box-shadow: ${({
  boxShadow
}: StyledBoxProps) => shadows[boxShadow as keyof typeof shadows] || 'none'};
  width: ${({
  width
}: StyledBoxProps) => width ? `${width}` : 'auto'};

  ${({
  onClick
}: StyledBoxProps) => onClick && `
    cursor: pointer;
    transition: all 0.2s ease-out;
    &:hover {
      transform: scale(1.005);
      border-color: ${newColors.brand[200]};
    }
    `}
`;